import FormSelect from 'common/components/form/FormSelect';
import { Ref, useImperativeHandle, useMemo, useState } from 'react';
import _ from 'lodash';
import { APPROVAL_STATUS } from 'common/types/documentRequirements';
import { styled } from 'styled-components';
import Config from 'Config';
import { FilterItem } from './DocumentRequirementsPhotoSearchAndFilter';
import { generateRandomUUID } from '../../../utils/Utils';
import { optionRadioRenderer } from './DocumentRequirementsPhotoFilterMediaType';

interface DocumentRequirementsPhotoFilterStatusProps {
    ref?: Ref<{ clearSelectedStatus: () => void }>;
    disabled: boolean;
    onSelectedStatusChanged: (status: FilterItem) => void;
    className?: string;
}

const DocumentRequirementsPhotoFilterStatus = ({
    onSelectedStatusChanged,
    ref,
    disabled = false,
    className,
}: DocumentRequirementsPhotoFilterStatusProps) => {
    const [selectedValue, setSelectedValue] = useState<
        FilterItem | undefined
    >();
    const [key, setKey] = useState(generateRandomUUID());

    const clearSelectedStatus = () => {
        setSelectedValue(undefined);
    };

    const handleOnChange = (item: FilterItem) => {
        onSelectedStatusChanged(item);
        setSelectedValue(item);
        setKey(generateRandomUUID());
    };

    useImperativeHandle(ref, () => ({
        clearSelectedStatus,
    }));

    const statusOptions = useMemo(() => {
        const options = [
            {
                name: 'All',
                value: 'ALL',
            },
        ];
        const statusOption = _.map(APPROVAL_STATUS, status => ({
            name: status.newUIDisplay,
            value: status.id,
        }));
        return [...options, ...statusOption];
    }, []);

    return (
        <StyledFormSelect
            key={key}
            options={statusOptions}
            placeholder='Status'
            onChange={handleOnChange}
            disabled={disabled}
            className={className}
            optionRenderer={props =>
                optionRadioRenderer({ ...props, selectedValue })
            }
            searchable={false}
        />
    );
};
export default DocumentRequirementsPhotoFilterStatus;

const StyledFormSelect = styled(FormSelect)`
    min-width: 120px;

    .select-wrapper__placeholder {
        color: ${Config.color.darkNavy};
        font-size: 14px;
        font-weight: 600;
    }

    .select-wrapper__control--menu-is-open {
        background-color: ${Config.color.darkNavy};
        & .select-wrapper__placeholder,
        .fa-caret-up {
            color: ${Config.color.white};
        }
    }

    .select-wrapper__control--is-focused {
        border-color: ${Config.color.inputBorderGray} !important;
    }

    .select-wrapper--is-disabled {
        .select-wrapper__placeholder {
            color: #65768f;
        }
    }
`;
